/** Compare a list snapshot with a task PATCH already confirmed by the server. */
export interface ConfirmedTaskStatus {
  status: string;
  confirmedAt: number;
  updatedAt: number | null;
}

export interface RelatedTaskSnapshot {
  status: string | null;
  updatedAt: number | null;
}

export function reconcileRelatedTaskStatus(
  confirmed: ConfirmedTaskStatus | undefined,
  snapshot: RelatedTaskSnapshot,
  fetchStartedAt: number,
): "apply" | "ignore" | "refresh" {
  if (!confirmed) return "apply";
  if (fetchStartedAt <= confirmed.confirmedAt) return "ignore";
  if (snapshot.updatedAt !== null && confirmed.updatedAt !== null) {
    return snapshot.updatedAt >= confirmed.updatedAt ? "apply" : "ignore";
  }
  // Older servers omit task timestamps. Keep the confirmed color while a
  // per-task GET resolves any conflicting newer list response.
  return snapshot.status === confirmed.status ? "apply" : "refresh";
}
